import PageNames from "../../../models/domain/enums/page_names";
import RoutingEvents from "../../../services/routing_events";
import { PageOption } from "../nav_bar_pages_dropdown";

export type NavRouteContext = {
  organizationId: string
  projectId: string
  floorId: string
  scanDatasetId: string
};

// Mirrors the routing resolution in nav_bar_page_option.tsx so the reskinned nav links point to
// exactly the same destinations as the legacy dropdown. Operations (whose pageNames include
// PROJECT) uses the superadmin/project signature; everything else uses the project signature.
// Returns null when the option has no route (the Schedules placeholder).
const resolveNavRoute = (pageOption: PageOption, ctx: NavRouteContext): RoutingEvents | null => {
  return pageOption.pageNames.has(PageNames.PROJECT)
    ? pageOption.routingEvent(ctx.organizationId, ctx.projectId, ctx.floorId, ctx.scanDatasetId, pageOption.pageNames)
    : pageOption.routingEvent && pageOption.routingEvent(ctx.projectId, ctx.floorId, ctx.scanDatasetId, pageOption.pageNames);
};

export default resolveNavRoute;
